<!--
 Categories Shop Facet Component
 Shows available shop categories for given search input
 devs@droxit.de
 Copyright (c) 2022 droxIT GmbH
-->

<template>
  <b-container fluid="md" v-if="showFacet">
    <div class="header-cell border-header">
      <b-row class="rocketsearch-column-header-text">
        <span> {{ facet.label }} </span>
      </b-row>
    </div>
    <b-row>
      <b-col>
        <b-row class="row" v-for="category in facet.options" :key="category.key">
          <span :class="get_class(category)" style="cursor: pointer">
            <span v-on:click="select_category(category)">
              {{ category.value }} ({{category.num}})
            </span>
            <button
              class="close b-form-tag-remove"
              type="button"
              v-on:click="deselect_category()"
              v-show="selected_category.includes(category.value)"
              style="padding-left: 3px;"
            >
              ×
            </button>
          </span>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'CategoryFacetComputer',
    props: {
      facet: Object,
      filter: Array
    },
    data: function(){
      return {
        selected_category: this.filter || []
      }
    },
    watch: {
      selected_category: function(options){
        this.setFilter(options);
      }
    },
    computed: {
      showFacet: function(){
        if (Object.keys(this.facet).length === 0) {
          return false;
        }
        return this.facet.options.length > 0;
      }
    },
    methods: {
      setFilter: function (selected) {
        this.$root.$emit('RocketFilterSelectedEvent', { name: this.facet.name, options: selected });
      },
      select_category(category){
        this.selected_category = [category.value];
      },
      deselect_category(){
        this.selected_category = [];
      },
      get_class(category){
        if(this.selected_category.includes(category.value)){
          return "selected-category"
        }
        return ""
      }
    }
  }
</script>
